module.exports = __webpack_public_path__ + "static/media/b4.9a4587af.png";